import React from "react";
import { WorkspaceLink } from "../hooks/useWsNavigate";
import { ExternalLink } from "lucide-react";
import Button from "./ui/Button";

const EmptyState = ({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  learnMoreLink,
  compact = false,
}) => {
  return (
    <div className={`flex items-center justify-center p-4 ${compact ? "py-12" : "min-h-[80vh]"}`}>
      <div className="flex flex-col items-center justify-center py-12 px-8 bg-card max-w-lg w-full">
        {/* Icon */}
        {Icon && (
          <div className="mb-6">
            <Icon className="h-12 w-12 text-muted-foreground" />
          </div>
        )}

        {/* Title */}
        <h3 className="text-xl font-semibold text-foreground mb-3">{title}</h3>

        {/* Description */}
        <p className="text-muted-foreground text-center max-w-sm mb-8">{description}</p>

        {/* Actions */}
        <div className="flex items-center gap-3 mb-6">
          {primaryAction && (
            <Button variant="black" onClick={primaryAction.onClick}>
              {primaryAction.icon && (
                <primaryAction.icon className="h-4 w-4 mr-2" />
              )}
              {primaryAction.label}
            </Button>
          )}
          {secondaryAction && (
            <Button variant="secondary" onClick={secondaryAction.onClick}>
              {secondaryAction.icon && (
                <secondaryAction.icon className="h-4 w-4 mr-2" />
              )}
              {secondaryAction.label}
            </Button>
          )}
        </div>

        {/* Learn More Link */}
        {learnMoreLink && (
          <WorkspaceLink
            to={learnMoreLink.href}
            className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors text-sm"
          >
            <span>{learnMoreLink.label || "Learn More"}</span>
            <ExternalLink className="h-4 w-4" strokeWidth={1.5} />
          </WorkspaceLink>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
